

















































import getVSelectOptionByValue from "piramis-js-utils/lib/getVSelectOptionByValue";
import { Component, Mixins } from 'vue-property-decorator'
import vSelect from 'vue-select'

import { SelectOption } from "../../logic/types";
import FieldWrapper from '../Pi/components/FieldWrapper.vue'
import SelectInput from '../Pi/fields/SelectInput/SelectInput.vue'
import VueSelectOption from '../Pi/fields/SelectInput/components/SelectOption.vue';
import { SelectInputData } from '../Pi/fields/SelectInput/types'
import { BaseInput } from '../Pi/mixins'
import CurrencyInput from './components/input.vue'
import { MultiCurrencySettings } from './types'

@Component({
  components: {
    FieldWrapper,
    SelectInput,
    CurrencyInput,
    vSelect,
    VueSelectOption
  },
})
export default class MultiCurrencyInput extends Mixins(BaseInput) {
  inputTemplate = 0

  get multiCurrencyInputSettings(): MultiCurrencySettings {
    return this.settings as MultiCurrencySettings
  }

  get cost(): number {
    return this.multiCurrencyInputSettings.model[this.multiCurrencyInputSettings.key].cost
  }

  set cost(value: number) {
    if (this.settings.setter) {
      this.settings.setter({ cost: value, currency: this.currentCurrency })
    }
  }

  get currentCurrency(): SelectOption {
    return this.multiCurrencyInputSettings.model[this.multiCurrencyInputSettings.key].currency
  }

  set currentCurrency({ label, value }: SelectOption) {
    if (this.settings.setter) {
      this.settings.setter({ cost: this.cost, currency: value })
    }
  }

  get currencyDisplay(): string {
    return this.multiCurrencyInputSettings.currencyDisplay ? this.multiCurrencyInputSettings.currencyDisplay : 'symbol'
    // "symbol" to use a localized currency symbol such as "€" (default value)
    // "narrowSymbol" to use a narrow format symbol ("$100" rather than "US$100")
    // "code" to use the ISO currency code
    // "name" to use a localized currency name such as "dollar"
    // "hidden" to hide the currency
  }

  get selectInputSettings(): SelectInputData {
    return this.settings as SelectInputData
  }
}
